module.exports = __webpack_public_path__ + "img/save-the-world.8a13a2ba.png";